const upsellCtas = document.querySelectorAll('[data-upsell-cta]');
const cartDrawer =
  document.querySelector("cart-notification") ||
  document.querySelector("cart-drawer");

const handleUpsellCtaClick = (event, cartDrawer) => {
  event.preventDefault();
  const variantId = event.currentTarget.dataset.upsellCta;
  const product = {
    id: variantId,
    quantity: 1
  };

  const productData = {
    items: [product]
  };

  const config = fetchConfig('json');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';

  if (cartDrawer) {
    productData.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
    productData.sections_url = window.location.pathname;
    cartDrawer.setActiveElement(document.activeElement);
  }

  config.body = JSON.stringify(productData);

  fetch(window.routes.cart_add_url + `.js`, config)
  .then(response => response.json())
  .then(data => {
    cartDrawer.classList.remove('is-empty');
    cartDrawer.renderContents(data)
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};

upsellCtas.forEach((cta) => {
  cta.addEventListener('click', (event) => handleUpsellCtaClick(event, cartDrawer));
});

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const upsellCtas = document.querySelectorAll('[data-upsell-cta]');
  upsellCtas.forEach((cta) => {
    cta.removeEventListener('click', handleUpsellCtaClick);
    cta.addEventListener('click', (event) => handleUpsellCtaClick(event, cartDrawer));
  });
});